export function ProgressBar({ value = 0, className = "", testId }) {
  return (
    <div className={`w-full h-2.5 rounded-full bg-[#E5E7EB] overflow-hidden ${className}`} data-testid={testId}>
      <div
        className="h-full bg-[#003d9b] rounded-full transition-[width] duration-500"
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
}
